import React from 'react';
import { Grid, Box } from 'theme-ui';
import PrimaryExpert from './PrimaryExpert';
import SecondaryExpert from './SecondaryExpert';
import { useTheme } from '~/gatsby-plugin-theme-ui';
type Props = {
  experts: Queries.ActivityExpertFragment[];
  primaryColor: string;
  secondaryColor: string;
};
const ExpertSection = ({ experts, primaryColor, secondaryColor }: Props) => {
  const { theme } = useTheme();
  const getGridTemplateAreas = (length: number) => {
    switch (length) {
      case 1:
        return `
          "primaryExpert"
        `;
      case 2:
        return `
          "primaryExpert"
          "secondaryExperts"
        `;

      case 3:
        return [
          `"primaryExpert"
          "secondaryExperts"
       
          `,
          null,
          `
          "primaryExpert primaryExpert primaryExpert"
          "secondaryExperts secondaryExperts secondaryExperts"
          `,
        ];
    }
  };

  const getSubGridTemplateAreas = (length: number) => {
    switch (length) {
      case 1:
        return `
          "secondaryExpert0"
        `;
      case 2:
        return [
          `"secondaryExpert0"
                  "divider"
                  "secondaryExpert1"
                  `,
          null,
          `
          "secondaryExpert0 divider secondaryExpert1"
        `,
        ];
    }
  };

  const numberOfExperts = experts.length;
  const [firstExpert, ...restOfExperts] = experts;
  return (
    <Box sx={{ backgroundColor: secondaryColor }}>
      <Grid
        sx={{
          pb: [numberOfExperts === 1 ? 0 : '8rem', numberOfExperts === 1 ? 0 : '11.2rem'],
          rowGap: ['4rem', '5.6rem', '4rem'],
          columnGap: 0,
          gridTemplateAreas: getGridTemplateAreas(numberOfExperts),
        }}
      >
        <PrimaryExpert expert={firstExpert} numberOfExperts={numberOfExperts} backgroundColor={primaryColor} />
        {Boolean(restOfExperts.length) && (
          <Box
            sx={{
              gridArea: 'secondaryExperts',
              px: [0, '8rem'],
              pt: ['1.6rem', '14rem'],
              mt: [0, '-10rem'],
              backgroundColor: secondaryColor,
              width: '100%',
            }}
          >
            <Grid
              sx={{
                gridTemplateAreas: getSubGridTemplateAreas(restOfExperts.length),
                maxWidth: 'var(--max-width)',
                mx: 'auto',
                rowGap: ['4rem', '5.6rem', '4rem'],
              }}
            >
              {restOfExperts.map((expert, index) => {
                const hasNextExpert = index + 1 < restOfExperts.length && numberOfExperts > 2;
                if (hasNextExpert) {
                  return (
                    <>
                      <SecondaryExpert
                        key={expert.id}
                        expert={expert}
                        index={index}
                        numberOfExperts={numberOfExperts}
                        backgroundColor={secondaryColor}
                      />
                      <div
                        sx={{
                          gridArea: 'divider',
                          backgroundColor: secondaryColor,
                          px: ['2.4rem', '4rem'],
                          pt: [0, 0, '14rem'],
                          mt: [0, 0, '-10rem'],
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <div
                          sx={{
                            width: ['100%', null, '0.1rem'],
                            height: ['0.1rem', null, '100%'],
                            backgroundColor: theme.colors.olive.regular,
                          }}
                        />
                      </div>
                    </>
                  );
                }
                return (
                  <SecondaryExpert
                    key={expert.id}
                    expert={expert}
                    index={index}
                    numberOfExperts={numberOfExperts}
                    backgroundColor={secondaryColor}
                  />
                );
              })}
            </Grid>
          </Box>
        )}
      </Grid>
    </Box>
  );
};

export default ExpertSection;
